module.exports = __webpack_public_path__ + "static/img/UOOYAA_13_内容高清预览_页面_092.5f7d588.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue13/Ukrzaliznytsia/UOOYAA_13_内容高清预览_页面_092.jpg
// module id = n0kb
// module chunks = 7